import { Box } from "@mui/material";
import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { TaxSeasonBanner, type TaxSeasonBannerSourceUI } from "./TaxSeasonBanner";

interface TaxSeasonBannerContainerProps {
  sourceUI: TaxSeasonBannerSourceUI;
}

export function TaxSeasonBannerContainer(props: TaxSeasonBannerContainerProps) {
  const { sourceUI } = props;

  const worker = useDefinedWorker();
  const workerTimezone = worker.tmz;

  const form1099UiConfig = useCbhFlag(CbhFeatureFlag.FORM_1099_UI, {
    defaultValue: { enabled: false },
  });

  useLogEffect(
    APP_V2_USER_EVENTS.TAX_SEASON_BANNER_SHOWN,
    {
      sourceUI,
      timezone: workerTimezone,
    },
    { enabled: form1099UiConfig.enabled }
  );

  if (!form1099UiConfig.enabled) {
    return null;
  }

  const { taxationYear, formIssuanceThresholdInDollars } = form1099UiConfig;

  return (
    // Box is added here as it's a "div" required for TaxSeasonBanner to
    // have a way to grow in height more than the default height of the banner.
    // This is specifically required in the Shift Discovery page as the banner
    // is placed in a container that is taller than the banner itself due to the clipboard card.
    <Box>
      <TaxSeasonBanner
        sourceUI={sourceUI}
        timezone={workerTimezone}
        taxationYear={taxationYear}
        formIssuanceThresholdInDollars={formIssuanceThresholdInDollars}
      />
    </Box>
  );
}
